/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LayersBringToFrontIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Layers Bring To Front',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 8h2.007v25a.988.988 0 0 0 .987 1h.992a1 1 0 0 0 1-1l.007-25H9a.5.5 0 0 0 .5-.5.49.49 0 0 0-.147-.35L5.816 3.113a.5.5 0 0 0-.632 0L1.647 7.146A.49.49 0 0 0 1.5 7.5.5.5 0 0 0 2 8ZM23 1a1.2 1.2 0 0 0-.629.178l-11.99 7.141a.8.8 0 0 0 0 1.362l11.99 7.141a1.2 1.2 0 0 0 1.249.006l11.993-7.143a.8.8 0 0 0 .007-1.366L23.629 1.178A1.194 1.194 0 0 0 23 1ZM31.726 24l-2.54 1.513L31.682 27 23 32.17 14.318 27l2.5-1.487L14.274 24l-3.893 2.319a.8.8 0 0 0 0 1.362l11.99 7.141a1.2 1.2 0 0 0 1.249.006l11.993-7.143a.8.8 0 0 0 .007-1.366Z"
    />
    <path
      d="m31.726 15-2.54 1.513L31.682 18 23 23.17 14.318 18l2.5-1.487L14.274 15l-3.893 2.319a.8.8 0 0 0 0 1.362l11.99 7.141a1.2 1.2 0 0 0 1.249.006l11.993-7.143a.8.8 0 0 0 .007-1.366Z"
    />
  </svg>`;
};
